import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import { deliveryStatusList, statusList } from "../../data";

const dash = (value) => (value ? value : "---------");

const DetailRow = ({ label, children }) => (
  <Box sx={{ mb: 1.5, textAlign: "left" }}>
    <Typography
      variant="small"
      color="text.secondary"
      sx={{ display: "block", mb: 0.25 }}
    >
      {label}
    </Typography>
    <Box sx={{ fontWeight: 500, color: "#0F1624", fontSize: "14px" }}>
      {children}
    </Box>
  </Box>
);

const ChipList = ({ items, getLabel }) => {
  if (!items?.length) {
    return "---------";
  }

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
      {items.map((item, index) => (
        <Chip
          key={`${getLabel(item)}-${index}`}
          size="small"
          label={getLabel(item)}
          variant="outlined"
        />
      ))}
    </Box>
  );
};

const RepairDetailsDialog = ({ open, onClose, repair, lastStatus }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  // const lastStatus = repair?.repair_status_history_data?.length
  //   ? repair.repair_status_history_data[
  //       repair.repair_status_history_data.length - 1
  //     ]
  //   : null;

  const repairStatusColor =
    statusList.find((el) => el.name === lastStatus?.repair_status_name)
      ?.color || "";
  const deliveryStatusColor =
    deliveryStatusList?.find(
      (el) => el.name === lastStatus?.repair_delivery_status_name,
    )?.color || "";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullScreen}
      fullWidth
      maxWidth="sm"
      sx={{
        "& .MuiPaper-root": {
          borderRadius: fullScreen ? 0 : "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          color: "#0F1624",
          position: "relative",
          pr: 6,
          borderBottom: "1px solid #EAECF1",
        }}
      >
        Repair Details ({dash(repair?.repair_id)})
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ px: 2, py: 2 }}>
        <DetailRow label="Date">
          {repair?.created_at
            ? moment(repair.created_at).format("DD/MM/YYYY")
            : "---------"}
        </DetailRow>
        <DetailRow label="Branch">
          {dash(repair?.branch_data?.[0]?.name)}
        </DetailRow>
        <DetailRow label="Customer">
          {dash(repair?.customer_data?.[0]?.name)}
        </DetailRow>
        <DetailRow label="Mobile">
          {dash(repair?.customer_data?.[0]?.mobile)}
        </DetailRow>
        <DetailRow label="Model">
          {dash(repair?.model_data?.[0]?.name)}
        </DetailRow>
        <DetailRow label="Brand">
          {dash(repair?.brand_data?.[0]?.name)}
        </DetailRow>
        <DetailRow label="Serial">{dash(repair?.serial)}</DetailRow>
        <DetailRow label="Pass Code">{dash(repair?.pass_code)}</DetailRow>
        <DetailRow label="Issues">
          <ChipList
            items={repair?.issues}
            getLabel={(item) => `${item.name} - (${item?.repair_cost} TK)`}
          />
        </DetailRow>
        <DetailRow label="Spare Parts">
          <ChipList
            items={repair?.product_details}
            getLabel={(item) => `${item.name} - (${item?.price} TK)`}
          />
        </DetailRow>
        <DetailRow label="Repair Status">
          {lastStatus?.repair_status_name ? (
            <Chip
              label={lastStatus.repair_status_name}
              variant="outlined"
              sx={{ border: 0, backgroundColor: repairStatusColor }}
            />
          ) : (
            "---------"
          )}
        </DetailRow>
        <DetailRow label="Delivery Status">
          {lastStatus?.repair_delivery_status_name ? (
            <Chip
              label={lastStatus.repair_delivery_status_name}
              variant="outlined"
              sx={{ border: 0, backgroundColor: deliveryStatusColor }}
            />
          ) : (
            "---------"
          )}
        </DetailRow>
        <DetailRow label="Repair By">
          {dash(repair?.repair_by_data?.[0]?.name)}
        </DetailRow>
      </DialogContent>
      <DialogActions sx={{ px: 2, py: 1.5, borderTop: "1px solid #EAECF1" }}>
        <Button variant="outlined" color="info" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RepairDetailsDialog;
